import React from 'react';
import RequireUserProfile from '../src/components/RequireProfile';
import { Icon } from '@chakra-ui/react';
import {
  MdBuild,
  MdAddTask,
  MdVerifiedUser,
  MdGroups,
  MdSupervisorAccount,
  MdAdminPanelSettings,
  MdWater,
  MdPerson,
  MdLock,
  MdMenuBook,
} from 'react-icons/md';

//  Técnico 
import MinhasOS             from 'views/admin/tecnico/MinhasOS';
import RegistrarAtendimento from 'views/admin/tecnico/RegistrarAtendimento';

//  Supervisor 
import PainelSupervisor from 'views/admin/supervisor/PainelSupervisor';

//  Admin 
import PainelAdmin from 'views/admin/adminPanel/PainelAdmin';

//  Cliente 
import Acompanhamento from 'views/admin/cliente/Acompanhamento';

//  Manual 
import Manual from 'views/admin/manual/Manual';

//  Compartilhados 
import Validacoes from 'views/admin/validacoes/Validacoes';
import Equipes           from 'views/admin/equipes/Equipes';

//  Usuários / Perfil 
import UserNew         from 'views/admin/main/users/newUser';
import UsersOverview   from 'views/admin/main/users/overview';
import AccountSettings from 'views/admin/main/account/settings';

//  Auth 
import ForgotPasswordDefault from 'views/auth/forgotPassword/ForgotPasswordDefault.jsx';
import LockDefault           from 'views/auth/lock/LockDefault.jsx';
import SignInDefault          from 'views/auth/signIn/SignInDefault.jsx';
import SignUpDefault          from 'views/auth/signUp/SignUpDefault.jsx';
import VerificationDefault    from 'views/auth/verification/VerificationDefault.jsx';

/**
 * roles: array de roles que podem VER este item na sidebar.
 * undefined/null = visível para todos os roles autenticados.
 * 'tecnico' | 'supervisor' | 'admin' | 'cliente'
 */
const routes = [

  //  Técnico: Início (MinhasOS)
  {
    name: 'Início',
    path: '/tecnico/minhas-os',
    icon: <Icon as={MdBuild} width="20px" height="20px" color="inherit" />,
    layout: '/admin',
    component: <MinhasOS />,
    roles: ['tecnico','supervisor','admin'],
  },

  //  Técnico: Registrar Atendimento 
  {
    name: 'Registrar Atendimento',
    path: '/tecnico/registrar',
    icon: <Icon as={MdAddTask} width="20px" height="20px" color="inherit" />,
    layout: '/admin',
    component: <RegistrarAtendimento />,
    roles: ['tecnico','supervisor','admin'],
  },

  //  Supervisor: Painel 
  {
    name: 'Validações',
    path: '/validacoes',
    icon: <Icon as={MdVerifiedUser} width="20px" height="20px" color="inherit" />,
    layout: '/admin',
    component: <Validacoes />,
    roles: ['supervisor', 'admin'],
  },

  //  Admin: Painel 
  {
    name: 'Painel Administrativo',
    path: '/admin-panel',
    icon: <Icon as={MdAdminPanelSettings} width="20px" height="20px" color="inherit" />,
    layout: '/admin',
    component: <PainelAdmin />,
    roles: ['admin'],
  },

  //  Cliente: Acompanhamento 
  {
    name: 'Acompanhamento',
    path: '/cliente/acompanhamento',
    icon: <Icon as={MdWater} width="20px" height="20px" color="inherit" />,
    layout: '/admin',
    component: <Acompanhamento />,
    roles: ['cliente'],
  },

  //  Manual do Usuário (visível para todos os roles) 
  {
    name: 'Manual',
    path: '/manual',
    icon: <Icon as={MdMenuBook} width="20px" height="20px" color="inherit" />,
    layout: '/admin',
    component: <Manual />,
  },

  //  Validações (supervisor, admin) 


  //  Equipes (supervisor, admin) 
  {
    name: 'Equipes',
    path: '/equipes',
    icon: <Icon as={MdGroups} width="20px" height="20px" color="inherit" />,
    layout: '/admin',
    component: <Equipes />,
    roles: ['admin'],
    invisible: true,
  },

  //  Rotas invisíveis 
  {
    name: 'Usuários',
    layout: '/admin',
    path: '/main/users/users-overview',
    icon: <Icon as={MdPerson} width="20px" height="20px" color="inherit" />,
    exact: false,
    component: <UsersOverview />,
    invisible: true,
  },
  {
    name: 'Cadastro de Perfil',
    layout: '/auth',
    path: '/new-user',
    component: (
      <RequireUserProfile mode="new-user-only">
        <UserNew />
      </RequireUserProfile>
    ),
    invisible: true,
  },
  {
    name: 'Configurações',
    layout: '/admin',
    path: '/main/users/settings/:id',
    exact: false,
    component: <AccountSettings />,
    invisible: true,
  },

  //  Autenticação 
  {
    name: 'Autenticação',
    path: '/auth',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    collapse: true,
    invisible: true,
    items: [
      { name: 'Login',         path: '/sign-in',       collapse: true, items: [{ name: 'Default', layout: '/auth', path: '/sign-in/default',       component: <SignInDefault /> }] },
      { name: 'Criar Conta',   path: '/sign-up',       collapse: true, items: [{ name: 'Default', layout: '/auth', path: '/sign-up/default',       component: <SignUpDefault /> }] },
      { name: 'Verificação',   path: '/verification',  collapse: true, items: [{ name: 'Default', layout: '/auth', path: '/verification/default',  component: <VerificationDefault /> }] },
      { name: 'Bloquear Tela', path: '/lock',          collapse: true, items: [{ name: 'Default', layout: '/auth', path: '/lock/default',          component: <LockDefault /> }] },
      { name: 'Recuperar Senha', path: '/forgot-password', collapse: true, items: [{ name: 'Default', layout: '/auth', path: '/forgot-password/default', component: <ForgotPasswordDefault /> }] },
    ],
  },

];

export default routes;
